// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vaccine-info .v-icon {\n  color: #b3b3b3;\n  margin-right: 5px;\n}", ""]);
// Exports
module.exports = exports;
